var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"banner-top",attrs:{"color":"#c6d053"}},[_c('img',{attrs:{"src":_vm.smAndDown
        ? "/img/algoamais/banner_top_mobile.png"
        : "/img/algoamais/banner_top.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }